import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'ShowMoreButtonStyles-cvaRoot',
  'inline-flex items-center',
  'px-1.5 pt-1 pb-1.2',
  'cursor-pointer select-none',
  'rounded-[1.6rem] border-[1px] border-cBlack32',
  'transition-all duration-300',
  'hover:border-cBlack',
]);

export const cvaText = cva(['ShowMoreButtonStyles-cvaText', 'text-bodyM']);

export const cvaCount = cva([
  'ShowMoreButtonStyles-cvaCount',
  'flex items-center justify-center',
  'w-1.6 h-1.6',
  '-ml-0.4',
  'text-bodyXXS text-cWhite',
  'bg-cMediumGreen',
  'rounded-full border-0.1 border-cWhite',
]);
